import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position-absolute bg-white z-2 w-100 main-menu overflow-hidden" }
const _hoisted_2 = { class: "container position-relative d-flex flex-column h-100" }
const _hoisted_3 = {
  key: 1,
  class: "container text-center"
}
const _hoisted_4 = {
  key: 2,
  class: "row h-100"
}
const _hoisted_5 = { class: "col order-lg-last overflow-scroll overscroll-contain no-scrollbar h-100" }
const _hoisted_6 = { class: "col-12 col-lg-3 overflow-scroll overscroll-contain no-scrollbar h-100 border-end g-0 me-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _component_results = _resolveComponent("results")
  const _component_filters = _resolveComponent("filters")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-close position-absolute top-0 end-0 mx-3 my-4 p-2 rounded-circle border bg-white d-none d-lg-block",
        type: "button",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
      }),
      (_ctx.is_barcode)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "display-4 mt-4 text-decoration-none",
            href: "#",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.submit_barcode && $options.submit_barcode(...args)))
          }, [
            _createVNode(_component_icon, { name: "BARCODE" }),
            _createTextVNode(" " + _toDisplayString(_ctx.barcode_string), 1 /* TEXT */)
          ]))
        : (_ctx.loading.public_pages || _ctx.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "spinner-border muted m-5 p-5" }, null, -1 /* CACHED */)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_results, { pages: _ctx.results_data }, null, 8 /* PROPS */, ["pages"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_filters, {
                  action: $options.searchtab,
                  class: "mt-4",
                  filters: _ctx.filters,
                  selected: $props.filter
                }, null, 8 /* PROPS */, ["action", "filters", "selected"])
              ])
            ]))
    ])
  ]))
}